/**
 * Panier Maghla (demande client 22/09) : à la quantité minimale, le bouton
 * « − » d'une ligne du panier reste actif et retire l'article, dans le panier
 * latéral comme sur la page panier.
 *
 * Horizon désactive le « − » à la quantité minimale
 * (assets/component-cart-quantity-selector.js, `updateButtonStates`) et ne
 * propose que la corbeille. Sans modifier ce fichier core, le comportement
 * est complété sur la classe une fois définie : le « − » est réactivé à la
 * quantité minimale, et son clic passe la quantité à 0 par le chemin natif
 * (`onQuantityChange` → QuantitySelectorUpdateEvent → `cart-items-component`
 * retire la ligne, avec son animation). Seules les lignes du panier sont
 * concernées (`data-cart-line`), pas le sélecteur de la fiche produit.
 */
customElements.whenDefined('cart-quantity-selector-component').then((CartQuantitySelector) => {
  const proto = CartQuantitySelector.prototype;

  /**
   * @param {any} selector
   * @returns {boolean} La ligne est au minimum et peut être retirée.
   */
  const atMinimum = (selector) => {
    const { quantityInput } = selector.refs;
    if (!quantityInput?.dataset.cartLine) return false;
    const { min, value } = selector.getCurrentValues();
    return value <= min;
  };

  const updateButtonStates = proto.updateButtonStates;
  proto.updateButtonStates = function () {
    updateButtonStates.call(this);
    if (atMinimum(this)) this.refs.minusButton.disabled = false;
  };

  const decreaseQuantity = proto.decreaseQuantity;
  /** @param {Event} event */
  proto.decreaseQuantity = function (event) {
    if (!atMinimum(this)) return decreaseQuantity.call(this, event);
    event.preventDefault();
    this.refs.quantityInput.value = '0';
    this.onQuantityChange();
  };

  // Sélecteurs déjà rendus au moment du chargement
  for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
    /** @type {any} */ (selector).updateButtonStates?.();
  }
});
